import { getOr } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';

const getOptionsByMake = (state, props) =>
  getOr([], ['vehicle', 'model', props.makeValue, 'result'], state);

export default createStructuredSelector({
  options: getOptionsByMake,
});
